<template>
    <div class="main">
        <img :src="require('../../assets/bg.jpg')" class="bg_main"/>
        <div class="mainBox">
            <div class="main_header">
                <div class="main_1">
                    <div class="main_1_left">
                        <!-- <h2><router-link to="homeIndex"><img :src="require('../../assets/arrowb.png')"/></router-link> </h2> -->
                    </div>
                    <div class="main_1_right">
                        <div class="timeclear">
                            {{time}}
                            <!-- <el-date-picker
                            v-model="timeval"
                               format="yyyy-MM-dd hh:mm:ss"
                               type="date"
                               :clearable="false"
                              @change="onChange"
                               >
                            </el-date-picker> -->
                        </div>
                    </div>
                </div>
            </div>    
            <div class="main_body">
                <div class="main_2">
                    <div class="main_2_1">
                        <ul class="textlist1">
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(obj.today.finishweightsum,'decimal')" :duration='4000' :decimals="2" />
                                        <b>吨</b>
                                    </div>
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(obj.today.taskcnt,'number')" :duration='4000'/>
                                        <b>车</b>
                                    </div>
                                    <p>昨日累计运输</p>
                                </div>
                            </li>
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(thingStatObj.statdate.finishweightsum,'decimal')" :duration='4000' :decimals="2" />
                                        <b>吨</b>
                                    </div>
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(thingStatObj.statdate.taskcnt,'number')" :duration='4000'/>
                                        <b>车</b>
                                    </div>
                                    <p>本周累计运输</p>
                                </div>
                            </li>
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(obj.month.finishweightsum,'decimal')" :duration='4000' :decimals="2" />
                                        <b>吨</b>
                                    </div>
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(obj.month.taskcnt,'number')" :duration='4000'/>
                                        <b>车</b>
                                    </div>
                                    <p>本月累计运输</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="main_2_2">
                        <ul class="textlist2">
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(obj.year.finishweightsum,'decimal')" :duration='4000' :decimals="2" />
                                        <b>吨</b>
                                    </div>
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(obj.year.taskcnt,'number')" :duration='4000'/>
                                        <b>车</b>
                                    </div>
                                    <p>本年累计运输</p>
                                </div>
                            </li>
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(obj.total.finishweightsum,'decimal')" :duration='4000' :decimals="2" />
                                        <b>吨</b>
                                    </div>
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal="isEmpty(obj.total.taskcnt,'number')" :duration='4000'/>
                                        <b>车</b>
                                    </div>
                                    <p>总累计运输</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="main_2_3">
                        <ul class="textlist7">
                            <li>
                                <div class="title">
                                    <span class="green"></span>总车辆
                                </div>
                                <div class="info">
                                    <CountTo :startVal='0' :endVal="isEmpty(thinglist.length,'number')" :duration='4000'/>台
                                </div>
                            </li>
                            <li>
                                <div class="title">
                                    <span class="yellow"></span>行驶中
                                </div>
                                <div class="info">
                                    <CountTo :startVal='0' :endVal='transportData.length' :duration='4000'/>台
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="main_3">
                    <div class="main_3_1">
                        <div class="main_3_1_1">
                            <div class="title"><img :src="require('../../assets/title1.png')"/></div>
                            <div class="content">
                                <bar-chart :className="'main'" :mainChart='chartData1'/>
                            </div>
                        </div>
                        <div class="main_3_1_2" @click="onshow1">
                            <div class="title"><img :src="require('../../assets/title5.png')"/></div>
                            <div class="content">
                                <bar-chart1 :className="'main'" :mainChart='chartData2'/>
                            </div>
                        </div>
                    </div>
                    <div class="main_3_2">
                        <div class="main_3_2_1">
                            <div class='wrap'>
                                <ul>
                                    <li @click="onMarkChange('all')">
                                        <img :src="require('../../assets/all.png')" /><span>全部</span>
                                    </li>
                                    <li @click="onMarkChange(1)">
                                        <img :src="require('../../assets/car_online1.png')" /><span>蓝色：行驶中</span>
                                    </li>
                                    <li @click="onMarkChange(2)">
                                        <img :src="require('../../assets/car_online2.png')" /><span>红色：超速</span>
                                    </li>
                                    <li @click="onMarkChange(3)">
                                        <img :src="require('../../assets/car_online3.png')" /><span>黄色：停放</span>
                                    </li>
                                    <!-- <li @click="onMarkChange(4)">
                                        <img :src="require('../../assets/place.png')" /><span>矿山、搅拌站</span>
                                    </li> -->
                                    <li @click="onMarkChange(5)">
                                        <img :src="require('../../assets/place3.png')" /><span>充电站</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="map_content">
                                <div class="content">
                                    <p>今日运营车辆/总车辆</p>
                                    <span>{{operData.today}} / {{operData.total}}</span>
                                </div>
                                <div class="content">
                                    <p>今日里程/总里程(公里)</p>
                                    <span>{{operData.todaymileage}} / {{operData.totalmileage}}</span>
                                </div>
                            </div>
                            <div class="container"  ref="qqMap" ></div>
                        </div>
                    </div>
                    <div class="main_3_3">
                        
                        <div class="main_3_3_3 animate__animated animate__backInRight animate__delay-1s">
                            <div class="title"><img :src="require('../../assets/energy/title3_1.png')"/></div>
                            <div class="content">
                                <div class="tab">
                                    <span @click="getOper(1)" :class="operInfo.tabActive==1?'on':''">里程</span>
                                    <span @click="getOper(2)" :class="operInfo.tabActive==2?'on':''">时长</span>
                                </div>
                                <div class="tip">
                                    <!-- <div class="time_wrap">
                                        <div class="prev" @click="getOperTime(operInfo.prevTime)">
                                            {{operInfo.prevTime}}<span>上一日</span>
                                        </div>
                                        <div class="next" @click="getOperTime(operInfo.nextTime)">
                                            <span>下一日</span>{{operInfo.nextTime}}
                                        </div>
                                    </div> -->
                                    <div class="tip_wrap">
                                        <div>排行</div><span>车辆</span><p>{{operInfo.tabActive==1?'里程(km)':'时长(h)'}}</p>
                                    </div>
                                </div>
                                <div class="wrap">
                                    <vueSeamlessScroll :data="operInfo.list" :class-option="defaultOption" class="seamless-warp" v-if="operInfo.list.length>0">
                                    <ul class="textlist5">
                                        <li
                                        v-for="(item,index) in operInfo.list" :key="index"
                                        :class="'on'+(index+1)"
                                        >
                                            <div>{{item.rank}}</div>
                                            <span>{{item.thingregcode}}</span>
                                            <p>{{operInfo.tabActive==1?item.vehiclemileage:item.vehicleduration}}</p>
                                        </li>
                                    </ul>
                                    </vueSeamlessScroll>
                                </div>
                            </div>
                        </div>
                        
                        <div class="main_3_3_2 animate__animated animate__backInRight animate__delay-1s" @click="onshow2">
                            <div class="title"><img :src="require('../../assets/energy/title4_1.png')"/></div>
                            <div class="content">
                                <ul> 
                                    <li v-for="(item,index) in cdmInfo" :key="index">
                                        <div class="info_left">
                                            <span>{{item.num1}}{{item.unit1}}</span>
                                            <p>{{item.title1}}</p>
                                            <img :src="require('../../assets/energy/icon7.png')"/>
                                        </div>
                                        <div class="info_right">
                                            <div class="info1">
                                                <span>{{item.title2}}</span>
                                                <p>{{item.num2}}{{item.unit2}}</p>
                                            </div>
                                            <div class="info2">
                                                <span>{{item.title3}}</span>
                                                <p>{{item.num3}}{{item.unit3}}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- <div class="main_3_3_1 animate__animated animate__backInRight animate__delay-1s">
                            <div class="title"><img :src="require('../../assets/energy/title2.png')"/></div>
                            <div class="content">
                                <ul class="textlist6">
                                    <li >
                                        <div class="info">
                                            <div class="num">
                                                <CountTo :startVal='0' :endVal='obj.today&&obj.today.finishweightsum?parseInt(parseFloat(obj.today.finishweightsum)*0.3):0' :duration='4000'/>kg
                                            </div>
                                            <p>今日减少碳排放</p>
                                        </div>
                                        <img :src="require('../../assets/energy/icon5.png')" />
                                    </li>
                                    <li >
                                        <div class="info">
                                            <div class="num">
                                                <CountTo :startVal='0' :endVal='obj.total&&obj.total.finishweightsum?parseInt(parseFloat(obj.total.finishweightsum)*0.3):0' :duration='4000'/>kg
                                            </div>
                                            <p>累计减少碳排放</p>
                                        </div>
                                        <img :src="require('../../assets/energy/icon6.png')" />
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            
        </div>
        <div class="mask_main" @click="onhide" v-if="show1==1||show2==1||show3==1||show4==1"></div>
       
        <div :class="'transport_pup popup_main '+(show2==1?'animate__animated animate__backInRight':show2==2?'animate__animated animate__backOutRight':'')" v-if='show2==1||show2==2'>
            <div class="energy_1">
                <div class="title"><img :src="require('../../assets/energy/puptitle8.png')"/></div>
                <div class="content">
                    <div class="tip">
                        <p>车辆序号</p><p>车牌</p><p>司机姓名</p><p>司机电话</p><p>上一次充/换电时间</p><p>车辆剩余电量</p>
                    </div>
                    <div class="wrap">
                        <vueSeamlessScroll :data="thinglist" :class-option="defaultOption1" class="seamless-warp" v-if="thinglist.length>0">
                        <ul class="puplist energypup">
                            <li
                            v-for="(item,index) in thinglist" :key="index"
                            :class="'on'+(index+1)"
                            >
                                <div class="index">{{index+1}}</div>
                                <div class="thingregcode">{{item.thingregcode}}</div>
                                <div class="staffname">{{item.stafflist?item.stafflist[0].staffname:'**'}}</div>
                                <div class="tel">{{item.staffmobile?item.staffmobile:'***********'}}</div>
                                <div class="time">{{$formatime(item.modifytime,'ymdhm')}}</div>
                                <div :class="'num '+item.num<30?'red':item.num>50?'green':'yellow'">
                                    {{item.num}}%
                                </div>
                            </li>
                        </ul>
                        </vueSeamlessScroll>
                    </div>
                </div>
            </div>
        </div>
        
        
        <div :class="'transport_pup popup_main '+(show4==1?'animate__animated animate__backInLeft':show4==2?'animate__animated animate__backOutLeft':'')"
        v-if='show4==1||show4==2'
        >
            <div class="popup_1 charging_1">
                <div class="title"><img :src="require('../../assets/puptitle6.png')"/></div>
                <div class="content">
                    <ul class="puplist1">
                        <li
                        v-for="(item,index) in showObj4.list1" :key="index"
                        :class="'on'+(index+1)"
                        >
                            <div class="infoLeft">
                                <img :src="require('../../assets/charge'+(item.status=='0'?'3':item.status=='1'?'1':'2')+'.png')"/>
                                <p>
                                    {{item.status=="0"?'离线':item.status=="1"?'空闲':item.status=="2"?'已插枪':item.status=="3"?'充电中':item.status=="4"?'预约锁定':''}}
                                </p>
                            </div>
                            <div class="infoRight">
                                <div class="name">
                                    <i>{{item.power>10?'快':'慢'}}</i>{{item.title}}
                                </div>
                                <div class="id">枪编码{{item.connectorid}}</div>
                                <div class="power">最大功率{{item.power}}KW</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="popup_2 charging_2">
                <div class="title"><img :src="require('../../assets/puptitle7.png')"/></div>
                <div class="content">
                    <div class="tip">
                        <p>收费时段</p><p>优惠价(元/度)</p><p>电费</p><p>服务费</p>
                    </div>
                    <div class="wrap">
                        <ul class="puplist">
                            <li
                            v-for="(item,index) in showObj4.list" :key="index"
                            :class="'on'+(index+1)"
                            >
                                <div>{{item.time}}</div>
                                <span>{{item.total}}</span>
                                <p>
                                    {{item.electricity}}
                                </p>
                                <p>
                                    {{item.service}}
                                </p>
                            </li>
                            <li
                            v-for="(item,index) in showObj4.list" :key="index"
                            :class="'on'+(index+1)"
                            >
                                <div>{{item.time}}</div>
                                <span>{{item.total}}</span>
                                <p>
                                    {{item.electricity}}
                                </p>
                                <p>
                                    {{item.service}}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import Qs from 'qs';
    import CountTo from 'vue-count-to';
    import vueSeamlessScroll from "vue-seamless-scroll";
    import BarChart from '@/components/Echarts/BarChart'
    import BarChart1 from '@/components/Echarts/BarChart1'
    import {
        Toast
    } from 'vant';
    export default {
        name: '',
        components: {
            CountTo,
            vueSeamlessScroll,
            BarChart,
            BarChart1
        },
        computed: {

        },
        data() {
            return {
                obj:{
                    today:{finishweightsum:0,taskcnt:0},
                    week:{finishweightsum:0,taskcnt:0},
                    month:{finishweightsum:0,taskcnt:0},
                    year:{finishweightsum:0,taskcnt:0},
                    total:{finishweightsum:0,taskcnt:0}
                },
                thingStatObj:{
                    statdate:{finishweightsum:0,taskcnt:0},
                },
                widths: window.screen.width,
                transportData:[],
                //图表
                main5Chart: null,
                chartData1:[],
                chartData2:[],
                //时间
                time: this.$formatime(new Date().getTime(),'ymdhms', 'now'),
                timeval: this.$formatime(new Date().getTime()-24*60*60*1000, 'ymd', 'now'),
                list: [],
                listtotal: [],
                thinglist: [],
                operData:{
                    today:0,
                    total:0,
                    todaymileage:0,
                    totalmileage:0
                },
                
                tasktotal:[],
                //地图
                // markerArr: [],
                marker: [],
                infoWindow: [],
                map: null,
                bounds: new TMap.LatLngBounds(),
                maplist:[],
                addlist:[],
                addlist1:[],
                maplist1:[],//充电站
                //时间
                timer: null,
                //滚动
                defaultOption: {
                    step: 0.3,
                    limitMoveNum: 6,
                    // singleHeight: 20,
                    waitTime: 2000,
                    hoverStop: true,
                    // navigation:true,
                    openTouch: true,
                    switchSingleStep: true
                },
                defaultOption1: {
                    step: 0.3,
                    limitMoveNum: 9,
                    // singleHeight: 20,
                    waitTime: 2000,
                    hoverStop: true,
                    // navigation:true,
                    openTouch: true,
                    switchSingleStep: true
                },
                isroll: true,
                show1:0,
                show2:0,
                show3:0,
                show4:0,
                showObj4:{
                    list:[],
                    list1:[],
                },
                //切换mark
                marktype:'all',
                //运营排名
                operInfo:{
                    tabActive:1,
                    prevTime:this.$formatime(new Date().getTime()-86400000, 'ymd', 'now'),
                    nextTime:this.$formatime(new Date().getTime()+86400000, 'ymd', 'now'),
                    list:[],
                    toady:this.$formatime(new Date().getTime(), 'ymd', 'now')
                },
                //碳减排
                cdmInfo:[]
            }
        },
        created() {
        },

        mounted() {
            this.initMap();
            var that = this;
            window.addEventListener("resize", () => {
                that.widths = window.screen.width;
                clearInterval(that.timer);
                that.initMap(2);
                this.show1=0;
                this.show2=0;
                this.show3=0;
                this.show4=0;
            })
        },
        methods: {
            isEmpty(val,type){
                if(val&&val!='0'){
                    if(type=='number'){
                        return parseInt(val)
                    }else{
                        return parseFloat(val)
                    }
                }else{
                    return 0
                }
            },
            onshow1(){
                this.show1=1;
                this.show2=0;
                this.show3=0;
                this.show4=0;
                this.totalData(5);
            },
            onshow2(){
                this.show1=0;
                this.show2=1;
                this.show3=0;
                this.show4=0;
                // this.getthingtotal(6);
            },
            onshow3(){
                // this.show1=0;
                // this.show2=0;
                // this.show3=1;
                // this.show4=0;
                // this.getthingtotal(5);
            },
            onshow4(e){
                
                var lists=e.geometry.data.EquipmentInfos;
                var objlist=[];
                this.show1=0;
                this.show2=0;
                this.show3=0;
                this.show4=1;
                this.showObj4.list=this.organizeFees(e.geometry.data.ElectricityFee, e.geometry.data.ServiceFee);
                lists.forEach(items=>{
                    items.ConnectorInfos.forEach(item=>{
                        
                        objlist.push({
                            title:items.EquipmentName+item.ConnectorName,
                            status:item.Status,
                            connectorid:item.ConnectorID,
                            power:items.Power,
                        })
                    })
                })
                
                this.showObj4.list1=objlist;
            },
            onhide(){
                if(this.show1==1){
                    this.show1=2;
                }else if(this.show2==1){
                    this.show2=2;
                }else if(this.show3==1){
                    this.show3=2;
                }else if(this.show4==1){
                    this.show4=2;
                }
            },
            // onChange(val) {
            //     this.timeval = this.$formatime(val.getTime(), 'ymd', 'now');
            //     this.time = this.$formatime(val.getTime(), 'ymdhms', 'now');
            //     this.initData(1);
            // },
            goUrl(evt, type) {
                if(type=='3'){
                    this.$router.push({
                        path: '/sksjIndex',
                    });
                }else{
                    this.$router.push({
                        path: '/detail',
                        query: {
                            userid: type == 1 || type == 2 ? evt.userid : evt.geometry.properties.userid,
                            thingid: type == 1 || type == 2 ? evt.thingid : evt.geometry.id,
                            type: type ? type : 1,
                            thingpower:2
                        }
                    });
                }
            },
            getTimeByTimestamp(timeStamp) {
                var shenyu=timeStamp;//倒计时秒数
                var shengyuD=parseInt(shenyu/24*60%60);//转换为分
                var shengyuM=parseInt(shenyu/60%60);//转换为分
                var shengyuS=parseInt(shenyu % 60);//转换为秒
                return shengyuD+'天'+shengyuM+'分';
            },
            settime(type) {
                let _this = this;
                var countdown = 10;
                if (this.timer) {
                    clearInterval(_this.timer);
                }
                this.timer = setInterval(function() {
                    
                    if (countdown) {
                        countdown--
                        // if (!_this.timeval) {
                        //     _this.time = _this.$formatime(new Date().getTime(), 'ymdhms', 'now')
                        // }
                    } else {
                        clearInterval(_this.timer);
                        // if (!_this.timeval) {
                        //     _this.time = _this.$formatime(new Date().getTime(), 'ymdhms', 'now');
                        // }
                        _this.initMap(1);
                    }
                }, 1000)
            },

            initMap(type) {
                if (this.$store.state.configdata) {
                    if (type != 1 && type != 2) {
                        var center = new TMap.LatLng(39.984104, 116.307503); //设置中心点坐标
                        this.map = new TMap.Map(this.$refs.qqMap, {
                            center: center,
                            mapStyleId: 'style3',
                            showControl: false,
                        });
                    }
                    var _this = this;
                    let object = {
                        url: 'd=wxapi&c=emp_thing_super&m=vehicle_page',
                        data: {
                            rows: 1000,
                            thingpower:2
                        },
                        target: 'wuliu',
                        // islogin:true,
                        isheader:true,
                        success: res => {
                            var result = res.data;
                            this.transportData=[];
                            var d=100;
                            result.rows.forEach(item=>{
                                var vehiclespeed=item.vehiclespeed?parseInt(item.vehiclespeed):0;
                                d -= (Math.round(Math.random() + 0) + 1)
                                item.num=d;
                                if(vehiclespeed>0){
                                    this.transportData.push(item);
                                }
                            })
                            this.thinglist=result.rows;
                            this.thinglist.sort((a, b) =>  b.vehiclemileage-a.vehiclemileage); 
                            const oldSet = new Set(this.maplist.map(({thingid,maplat,maplng}) => thingid + "/" + maplat + "/" + maplng));
                            const newSet = new Set(result.rows.map(({thingid,maplat,maplng}) => thingid + "/" + maplat + "/" + maplng));
                            const x = [], y = [],z=[];
                            for (let obj of this.maplist) {  //删除
                                (newSet.has(obj.thingid + "/" + obj.maplat +"/" + obj.maplng )? z : x).push(obj);
                            }
                            for (let obj of result.rows) { //新增
                                (oldSet.has(obj.thingid + "/" + obj.maplat +"/" + obj.maplng ) ? z : y).push(obj);
                            } 
                            for (var i = 0; i < x.length; i++) {
                                for (var j = 0; j < _this.marker.length; j++) {
                                    if (_this.marker[j].id == x[i].thingid) {
                                        _this.marker[j].setMap(null);
                                        if(_this.infoWindow[j]){
                                            _this.infoWindow[j].setMap(null);
                                            _this.infoWindow.splice(j, 1);
                                        }
                                        _this.marker.splice(j, 1);
                                        j = j - 1;
                                    }
                                }
                            }
                            _this.setQQMap(y, type);
                            this.maplist=result.rows;
                            _this.settime()
                        },
                        complete: res => {
                            _this.initData(type);
                        }
                    }
                    this.$getData(object);
                }
            },
            onMarkChange(type){
                this.marktype=type;
                for (var j = 0; j < this.marker.length; j++) {
                    this.marker[j].setMap(null);
                    if(this.infoWindow[j]){
                        this.infoWindow[j].setMap(null);
                    }
                }
                this.marker=[];
                this.infoWindow=[];
                if(type==5){
                    this.setQQMap(this.maplist1,10)
                    
                }else if(type=='all'){
                    this.setQQMap(this.maplist)
                    this.setQQMap(this.maplist1,10)
                }else{
                    this.setQQMap(this.maplist)
                }
            },
            setQQMap(result, type) {
                var list = [];
                var obj=''
                for (var i = 0; i < result.length; i++) {
                    var data = result[i];
                    if(type=='9'||type=='10'||this.marktype=='5'){
                        if(data.StationLat>0&&data.StationLng>0&&data.StationID){
                            obj = {
                                "id": data.StationID,
                                "styleId": 'marker',
                                "position": new TMap.LatLng(data.StationLat, data.StationLng),
                                "content": data.placename,
                                "userid": data.StationID,
                                // 'placeaddr':data.placeaddr,
                                "style":4,
                                "maxZoom":10,
                                "data":data
                            }
                            list.push(obj);
                            this.createMarker(obj,type);
                        }
                    }else{
                        
                       if(data.maplat>0&&data.maplng>0){
                           // var warn=data.vehiclewarn?parseInt(data.vehiclewarn):0;
                           var warn=data.vehiclespeed?parseInt(data.vehiclespeed):0;
                           var strobj=this.$getPoliceType(warn,data);
                           if(this.marktype==2&&strobj.isred){
                               obj=this.setMapData(data,strobj)
                               list.push(obj);
                               this.createMarker(obj,type);
                           }else if(this.marktype==3&&strobj.isyellow){
                               obj=this.setMapData(data,strobj)
                               list.push(obj);
                               this.createMarker(obj,type);
                           }else if(this.marktype==1&&strobj.isblue){
                               obj=this.setMapData(data,strobj)
                               list.push(obj);
                               this.createMarker(obj,type);
                           }else if(this.marktype=='all'){
                               obj=this.setMapData(data,strobj)
                               list.push(obj);
                               this.createMarker(obj,type);
                           }
                       }  
                    }
                    
                }
                
                if (type!='9'&&type!='1') {
                    
                    this.showMarker(list)
                }

            },
            setMapData(data,strobj){
              var obj = {
                  "id": data.thingid,
                  "styleId": 'marker',
                  "position": new TMap.LatLng(data.maplat, data.maplng),
                  "rotate": 360 - Number(data.vehicledirection),
                  "content": data.thingregcode,
                  "speed": data.vehiclespeed,
                  "userid": data.userid,
                  "style":strobj.isred?2:strobj.isyellow?3:1,
                  'text':strobj.text,
                  "maxZoom":20,
              }
              return obj;
            },
            createMarker(data,type) {
                var _this = this;
                var mark = new TMap.MultiMarker({
                    id: data.id,
                    map: _this.map,
                    styles: {
                        "marker": new TMap.MarkerStyle({
                            "width": _this.setfontSize(30),
                            "height": _this.setfontSize(30),
                            "anchor": {
                                x: _this.setfontSize(30 / 2),
                                y: _this.setfontSize(30 / 2)
                            },
                            src: type==7?require('../../assets/place2.png'):type==8?require('../../assets/place.png'):type==9||type==10?require('../../assets/place3.png'):require('../../assets/car_online'+data.style+'.png'),
                            color: '#fff',
                            direction: 'bottom',
                            size: _this.setfontSize(14),
                            strokeColor: '#F69300',
                            rotate: type==7||type==8||type==9||type==10?0:data.rotate,
                        }),
                    },
                    geometries: [{
                        "id": data.id,
                        "styleId": 'marker',
                        "position": data.position,
                        "properties": {
                            "title": data.id,
                            "userid": data.userid
                        },
                        'maxZoom':data.maxZoom,
                        "content": type==7||type==8?data.content:'',
                        // "content":data.content,
                        'data':data.data?data.data:'',
                    }]
                })
                
                if(type==7||type==8){
                    this.marker.push(mark);
                }else if(type==9||type==10){
                    this.marker.push(mark);
                    // mark.on("click", this.onshow4);
                    // var objtext=this.getstr(data.data);
                    this.infoWindow.push(new TMap.InfoWindow({
                        map: _this.map,
                        enableCustom: true,
                        position: data.position,
                        zIndex:10,
                        offset: {
                            x: 0,
                            y: _this.setfontSize(-15)
                        }, //设置信息窗相对position偏移像素
                        content: "<div class='infowindow infowindow1'> <p>" + data.data.StationName + "</p></div>",
                        // <p style='margin:5px 0;'>当前" + this.addCurrentValues(data.data.ServiceFee,data.data.ElectricityFee) +
                        //     "元/度</p><p style='display:flex;justify-content: flex-end;'><span style='margin-right:20px'>快 "
                        //      + objtext.quickusable+'/'+objtext.quicktotal+ "</span><span>慢 " + objtext.smallusable+'/'+objtext.smalltotal+"</span></p></div>"
                    }))
                    
                }else{
                    this.marker.push(mark);
                    mark.on("click", this.goUrl);
                    this.infoWindow.push(new TMap.InfoWindow({
                        map: _this.map,
                        enableCustom: true,
                        position: data.position,
                        zIndex:10,
                        offset: {
                            x: 0,
                            y: _this.setfontSize(-15)
                        }, //设置信息窗相对position偏移像素
                        content: "<div class='infowindow'> <p>" + data.content + "</p><p>" + data.speed +
                            "公里/小时</p>"+data.text+"</div>"
                    }))
                }
            },
            
            showMarker(list) {
                //判断标注点是否在范围内
                var _this = this;
                list.forEach(function(item) {
                    //若坐标点不在范围内，扩大bounds范围
                    if (_this.bounds.isEmpty() || !_this.bounds.contains(item.position)) {
                        _this.bounds.extend(item.position);
                    }
                })
                // console.log(this.bounds)
                //设置地图可视范围
                this.map.fitBounds(this.bounds, {
                    padding: 100 // 自适应边距
                });
            },
            initData(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_total',
                    data: {
                        today: this.timeval,
                        totaltype: 'today,week,month,year,total',
                        thingpower:2
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        this.obj = result;
                    },
                    complete: res => {
                        this.thingStat(type);
                    }
                }
                this.$getData(object);
            },
            
            
            thingStat(type) {
                
                var _this = this;
                let object = {
                    url:'d=wxapi&c=emp_total&m=task_total',
                    // url: 'd=wxapi&c=emp_thing_super&m=thing_stat',
                    data: {
                        statdate:(this.$formatime(new Date(),'week','now','today').value).join(','),
                        totaltype:'statdate',
                        thingpower:2
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        this.thingStatObj = result;
                        
                    },
                    complete: res => {
                        this.todayData(type);
                    }
                }
                this.$getData(object);
            },
            todayData(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_total',
                    data: {
                        totaltype: 'day7',
                        thingpower:2,
                        today: this.timeval ? this.timeval : this.$formatime(new Date().getTime(), 'ymd', 'now')
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        this.chartData1=result.day7;
                    },
                    complete: res => {
                        this.totalData(type);
                    }
                }
                this.$getData(object);
            },
            totalData(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_group',
                    data: {
                        groupby: 'thingid',
                        thingpower:2,
                        rows:'10',
                        // taskdate:this.$formatime(new Date().getTime(), 'ym', 'now')
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        this.chartData2=result.rows;
                    },
                    complete: res => {
                        this.getCharge(type);
                    }
                }
                this.$getData(object);
            },
            getCharge(type){
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_evcs_order&m=station_page',
                    data: {},
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        const oldSet = new Set(this.maplist1.map(({StationID,StationLat,StationLng}) => StationID + "/" + StationLat + "/" + StationLng));
                        const newSet = new Set(result.StationInfos.map(({StationID,StationLat,StationLng}) => StationID + "/" + StationLat + "/" + StationLng));
                        const x = [], y = [],z=[];
                        for (let obj of this.maplist1) {  //删除
                            (newSet.has(obj.StationID + "/" + obj.StationLat +"/" + obj.StationLng )? z : x).push(obj);
                        }
                        for (let obj of result.StationInfos) { //新增
                            (oldSet.has(obj.StationID + "/" + obj.StationLat +"/" + obj.StationLng ) ? z : y).push(obj);
                        } 
                        for (var i = 0; i < x.length; i++) {
                            for (var j = 0; j < _this.marker.length; j++) {
                                if (_this.marker[j].id == x[i].StationID) {
                                    _this.marker[j].setMap(null);
                                    _this.infoWindow[j].setMap(null);
                                    _this.marker.splice(j, 1);
                                    _this.infoWindow.splice(j, 1);
                                    j = j - 1;
                                }
                            }
                        }
                        _this.setQQMap(y, 9);
                        this.maplist1=result.StationInfos
                    },
                    complete: res => {
                        if(type!=5){
                            _this.getthingtotal(type);
                        }
                    }
                }
                this.$getData(object);
            },
            getthingtotal(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_thing_super&m=thing_page',
                    data: {
                        rows:'1000',
                        orderby: 'modifytime',
                        thingpower:2
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _this.thinglist = result.rows;
                        var num=0,num1=0,num2=0;
                        result.rows.forEach(item=>{
                            num=num+parseFloat(item.vehiclemileage)
                            num2=num2+parseFloat(item.todaymileage)
                            if(parseFloat(item.todaymileage>0)){num1++}
                        })
                        
                        var ynum=0,dnum=0,treenum=0,treenum1=0,ymoney=0,ymoney1=0;
                        dnum=(num/3983).toFixed(2);
                        treenum=(dnum/99.88).toFixed(2);
                        treenum1=(treenum/0.24).toFixed(2)
                        ynum=(num/2.85).toFixed(2)
                        ymoney=(ynum*5.34/10000).toFixed(2)
                        ymoney1=(ynum*0.58/10000).toFixed(2)
                        
                        // ynum=parseFloat(num*2.3);
                        // console.log(ynum)
                        // dnum=parseFloat(num*0.7);
                        // console.log(dnum)
                        // dnum= ((ynum-dnum)/100000).toFixed(2)
                        // treenum=dnum/99.88
                        //39
                        // console.log(dnum)
                        this.cdmInfo=[
                            {'title1':'累计减少碳排放(吨)','num1':dnum,'title2':'相当于累计植树','num2':treenum,'unit2':'万棵','title3':'增加绿化面积','num3':treenum1,'unit3':'亩',},
                            {'title1':'累计节油(升)','num1':ynum,'title2':'节约油费','num2':ymoney,'unit2':'万元','title3':'较油车年平均创收','num3':ymoney1,'unit3':'万元',}
                        ]
                        this.operData={
                            today:num1,
                            total:this.thinglist.length,
                            todaymileage:num2,
                            totalmileage:num
                        }
                    },
                    complete: res => {
                        _this.getOper(this.operInfo.tabActive);
                    }
                }
                this.$getData(object);
            },
            getOperTime(data){
                this.operInfo.prevTime=this.$formatime(new Date(data).getTime()-86400000, 'ymd', 'now')
                this.operInfo.toady=this.$formatime(new Date(data).getTime(), 'ymd', 'now')
                this.operInfo.nextTime=this.$formatime(new Date(data).getTime()+86400000, 'ymd', 'now')
                this.getOper(this.operInfo.tabActive);
            },
            getOper(type) {
                this.operInfo.list=[]
                this.operInfo.tabActive=type;
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_thing_super&m=thing_page',
                    data: {
                        rows:'200',
                        orderby:type==1?'mileage':'duration' ,
                        thingpower:2,
                        // taskdate:this.operInfo.toady
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        result.rows.forEach((item,index)=>{
                            this.$set(item,'rank',index+1)
                        })
                        this.operInfo.list = result.rows;
                    },
                    complete: res => {
            
                    }
                }
                this.$getData(object);
            },
            setfontSize(res) {
                const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body
                    .clientWidth;
                if (!clientWidth) return;
                let fontSize = clientWidth / 1920;
                return parseInt(res * fontSize);
            },
            
            setChart5(data, type) {
                if (type == 1 || type == 3) {
                    this.main5Chart.setOption({
                        series: [{
                            data: data
                        }],
                    })
                    this.main5Chart.resize();
                } else if (type == 2) {
                    this.main5Chart.resize();
                } else {
                    this.main5Chart = this.$echarts.init(document.getElementById('main5'));
                    var option = {
                        tooltip: {
                            trigger: 'item',
                            formatter: function(params) {
                                var htmlStr = '';
                                htmlStr += '<div><span style="color:#000;">' + params.name + '</span><br/> ';
                                htmlStr +=
                                    '<span style="width: 8px;height: 8px;margin-right:5px; display:inline-block;border-radius: 50%;background-color:' +
                                    params.color + '"></span>';
                                htmlStr += '<span style="color:#000;margin-right:20px">' + params.seriesName +
                                    '</span><span style="color:#000;font-weight:bold;">' + params.value +
                                    ' 辆</span></div>';
                                return htmlStr
                            },
                        },
                        grid: {
                            // top: '2%',
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        series: [{
                            name: '车辆',
                            type: 'pie',
                            // radius:['80%','80%'],
                            center: ['50%', '50%'],
                            labelLine: {
                                "show": true,
                                "length": 1,
                                "length2": this.setfontSize(40)
                            },
                            avoidLabelOverlap: false,
                            label: {
                                // normal: {
            
                                // },
                                position: 'outer',
                                show: true,
                                alignTo: 'outer',
                                edgeDistance: '25%',
                                color: '#fff',
                                formatter: '{name|{b}}' + '\n\r' + '{num|{d}%}',
                                rich: {
                                    name: {
                                        fontSize: this.setfontSize(16),
                                        color: '#fff'
                                    },
                                    num: {
                                        fontSize: this.setfontSize(16),
                                        color: '#fff',
                                        lineHeight: this.setfontSize(30),
                                    },
                                }
                            },
                            bottom: 20,
                            top: 20,
                            data: data
                        }]
                    };
                    this.main5Chart.setOption(option);
                }
            },
            setChart6(items,type){
                var xdata=[],ydata=[];
                if(!this.main6Chart){
                    this.main6Chart = this.$echarts.init(document.getElementById('main6'));
                }
                items.month6.forEach((item,index)=>{
                    ydata.push((parseFloat(item.finishweightsum)*0.3).toFixed(2));
                    xdata.push(item.taskmonth);
                })
                if(type==1){
                    this.main6Chart.setOption({
                        series:[{data:ydata}],
                        xAxis:{data: xdata,}
                    })
                    this.main6Chart.resize();
                }else if(type==2){
                    this.main6Chart.resize();
                }else{
                    // this.main6Chart = this.$echarts.init(document.getElementById('main6'));
                    var option = {
                      xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xdata,
                        axisLabel: { //x轴文字的配置
                            show: true,
                            interval:0,
                            // rotate:30,
                            textStyle: {
                                color: "#fff",
                                fontSize: this.setfontSize(14)
                            },
                        },
                      },
                      tooltip: {
                          trigger: 'axis',
                          axisPointer: {
                              type: 'shadow'
                          },
                          formatter: function(params) {
                              var htmlStr = '';
                              htmlStr += '<div><span style="color:#000;">' + params[0].name + '</span><br/> ';
                              htmlStr +=
                                  '<span style="width: 8px;height: 8px;margin-right:5px; display:inline-block;border-radius: 50%;background-color:' +
                                  params[0].color + '"></span>';
                              htmlStr += '<span style="color:#000;margin-right:20px">' + params[0]
                                  .seriesName + '</span><span style="color:#000;font-weight:bold;">' + params[
                                      0].value + ' kg</span></div>';
                              return htmlStr
                          },
                      },
                      yAxis: {
                          type: 'value',
                          splitLine: { //分割线配置
                              show: true,
                              lineStyle: {
                                  color: "rgba(255,255,255,0.1)",
                              }
                          },
                          axisLabel: { //
                              show: true,
                              textStyle: {
                                  color: "#aaa",
                                  fontSize: this.setfontSize(14)
                              }
                          },
                      },
                      grid: {
                          top: '20px',
                          left: '20px',
                          right: this.setfontSize(30),
                          bottom: this.setfontSize(5),
                          containLabel: true
                      },
                      series: [
                        {
                            name: '减排量',
                          data: ydata,
                          type: 'line',
                          smooth: true,
                          lineStyle: { // 设置线条的style等
                              normal: {
                                  color: '#45AA56', // 折线线条颜色:绿色
                              },
                          },
                          label:{
                              show: true,
                              color: '#fff',
                              fontSize: this.setfontSize(12),
                              formatter:"{c}kg",
                          },
                          areaStyle: {
                            color: {
                              type: 'linear',
                              x: 0,
                              y: 0,
                              x2: 0,
                              y2: 1,
                              colorStops: [{
                                    offset: 0,  color: 'rgba(69,170,86,0.6)',opacity: 0.2  // 100% 处的颜色
                              }, {
                                    offset: 1, color: 'rgba(69,170,86,0.6)' //   0% 处的颜色
                              }],
                              global: false // 缺省为 false
                            }
                          },
                        }
                      ]
                    };
                    this.main6Chart.setOption(option);
                }
            },
            getstr(station){
                var obj={
                    total : 0,
                    usable : 0,
                    quicktotal : 0,
                    quickusable : 0,
                    smalltotal : 0,
                    smallusable : 0,
                };
                for (var equipment of station.EquipmentInfos) {
                  var setKey = ''
                  if (equipment.Power > 10) {
                    setKey = 'quick'
                  }else {
                    setKey = 'small'
                  }
                  for (var connecton of equipment.ConnectorInfos) {
                    if (connecton.Status == 1) {
                      obj.usable++;
                      obj[setKey+'usable'] ++;
                    }
                    obj.total++;
                    obj[setKey+'total'] ++;
                  }
                }
                return obj;
            },
            organizeFees(electricityData, serviceData) {
              const currentTime = new Date();
              const currentHour = currentTime.getHours();
              const currentMinute = currentTime.getMinutes();
              const electricityEntries = electricityData.split(";");
              const serviceEntries = serviceData.split(";");
              const resultArray = [];
              electricityEntries.forEach((electricityEntry, index) => {
                const serviceEntry = serviceEntries[index];
                if (electricityEntry && serviceEntry) {
                  const [electricityTime, electricityValue] = electricityEntry.split(",");
                  const [serviceTime, serviceValue] = serviceEntry.split(",");
            
                  if (electricityTime && electricityValue && serviceTime && serviceValue) {
                    const electricity = parseFloat(electricityValue) / 100;
                    const service = parseFloat(serviceValue) / 100;
                    const total = electricity + service;
                    const [startHour, startMinute] = electricityTime.split("~")[0].split(":").map(Number);
                    const [endHour, endMinute] = electricityTime.split("~")[1].split(":").map(Number);
                    const isCurrent = (currentHour > startHour || (currentHour === startHour && currentMinute >= startMinute)) &&
                      (currentHour < endHour || (currentHour === endHour && currentMinute <= endMinute));
                    resultArray.push({
                      electricity,
                      service,
                      total,
                      time: electricityTime,
                      current: isCurrent,
                    });
                  }
                }
              });
              // 根据 total 重新计算 tag
              const lowestTotal = Math.min(...resultArray.map(entry => entry.total));
              const highestTotal = Math.max(...resultArray.map(entry => entry.total));
              
              resultArray.forEach(entry => {
                if (entry.total == lowestTotal && resultArray.length > 1) {
                  entry.tag = 'min';
                }
                if (entry.total == highestTotal && resultArray.length > 1) {
                  entry.tag = 'max';
                }
              });
            
              return resultArray;
            },
            // 计算充电桩当前价格
            addCurrentValues(str1, str2) {
              str1 = str1.replace('服务费', '');
              str2 = str2.replace('电费:', '');
              // 查找并相加当前时间段的两个数值
              const sum1 = this.findAndAddValue(str1);
              const sum2 = this.findAndAddValue(str2);
              // 将结果除以100并保留两位小数
              const result = ((sum1 + sum2) / 100).toFixed(2);
              return result;
            },
            // 将字符串转换为对象
            parseString(str) {
              const obj = {};
              const segments = str.split(';');
              for (const segment of segments) {
                const [time, value] = segment.split(',');
                obj[time] = parseInt(value, 10);
              }
              return obj;
            },
            // 查找并相加当前时间段的两个数值
            findAndAddValue(str) {
              const obj = this.parseString(str);
              let sum = null;
              // 获取当前时间的小时和分钟
              const now = new Date();
              const currentHour = now.getHours();
              const currentMinute = now.getMinutes();          
              for (const [segment, value] of Object.entries(obj)) {
                const [start, end] = segment.split('~');
                const [startHour, startMinute] = start.split(':').map(Number);
                const [endHour, endMinute] = end.split(':').map(Number);
                        
                if (
                  (currentHour > startHour || (currentHour === startHour && currentMinute >= startMinute)) &&
                  (currentHour < endHour || (currentHour === endHour && currentMinute < endMinute))
                ) {
                  sum = value;
                  break;
                }
              }
              return sum;
            },
        },
        activated() {
            this.show1=0;this.show2=0;this.show3=0;this.show4=0;
            this.list=[];
            this.listtotal= [];
            this.thinglist= [];
            this.tasktotal=[];
        },
        destroyed() {
            console.log('进入销毁')
            if (this.timer) {
                console.log('开始销毁')
                clearInterval(this.timer);
            }
        },
        watch: {
            '$store.state.configdata'(val, oldVal) {
                if (!oldVal) {
                    this.initMap();
                }
            },
            '$route'(val, oldVal) {
                // console.log(val, oldVal)
                if (val.name=='energy'&&oldVal.name=='detail') {
                    console.log('重新开始1')
                    this.initMap(1);
                }else if (val.name=='energy'&&oldVal.name =='sksjindex') {
                    console.log('重新开始2')
                    this.initMap(1);
                }else if (val.name=='energy'&&oldVal.name =='homeIndex') {
                    console.log('重新开始2')
                    this.initMap(1);
                }else{
                    if (this.timer) {
                        console.log('开始销毁')
                        clearInterval(this.timer);
                    }
                }
                // if (val.name=='homeIndex'&&oldVal.name=='login') {
                //     // console.log('重新开始1')
                //     this.initMap(1);
                // }
            },
        },
    }
</script>
<style scoped lang="less">
    @import '../../style/css/variable.less';

    ::v-deep {
        // .bg_main {
        //     position: fixed;
        //     height: 100%;
        //     width: 100%;
        //     top: 0;
        //     right: 0;
        //     object-fit: fill;
        //     // background: rgba(23, 74, 156, 1);
        //     z-index: 999;
        // }
        .bg_main{
                position: fixed;
                height: 100%;
                width: 100%;
                    top: 0;
                    right: 0;
        }
        .mainBox {

            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            padding: 0 20px;
            background-size: 100% 100%;
            box-sizing: border-box;
            height: 100%;
            overflow: hidden;
            z-index: 999;
            .main_header{
                height: 8.8%;
                box-sizing: border-box;
               .main_1 {
                   position: relative;
                   height: 100%;
                   box-sizing: border-box;
                   .flex-center();
                   align-items: flex-start;
                   .main_1_left{
                       width:100%;height: 100%;
                       background: url('../../assets/top_bg3.png') no-repeat center;
                       background-size: 100%;
                       // h2 {
                       //     display: block;
                       //     font-size: 40px;
                       //     color: #5AD2F8;
                       //     text-align: center;
                       //     margin-top: 10px;
                       // }
                       a{position: absolute;right: 620px;top:50%;transform: translate(0,-50%);display: block;
                         img{
                             width:30px;height:30px;display: block;
                         }  
                       }
                       
                   }
                   .main_1_right {
                       position: absolute;
                       right:0;
                       top:12px;
                       .flex-between();
                       flex-flow: column;
                       align-items: flex-end;
                       .timeclear{
                           position: relative;
                           font-size: 14px;
                           color: #86A9D6;
                           position: relative;
                           
                           text-align: right;
                           .el-date-editor{
                               position: absolute;
                               left:50%;
                               top:50%;
                               transform: translate(-50%,-50%);
                               input{
                                   font-size: 0;
                                   border:none;
                                   background: none;
                                   color: #B3B5BD;
                               }
                           }
                       }
                       .backHome{
                           a{
                               margin:32px 0 0 0;
                               .flex-start();font-size: 20px;color: #fff;align-items: center;
                               img{width: 24px;display: block;margin-right: 9px;}
                           }
                          
                       }
                   }
               } 
            }
            .main_body{
                height:89.36%;
                .main_2{
                    .flex-between();
                    align-items: center;
                    height:19.5%;
                    .main_2_1{
                        width:47%;
                        height: 100%;
                    }
                    .main_2_2{
                        width:35%;
                        height:90%;
                        background: url(../../assets/main_2_2.png) no-repeat center;background-size:100% 100%;
                    }
                    .main_2_3{
                        width:15.74%;
                        height:90%;
                        background: url(../../assets/main_2_3.png) no-repeat center;background-size:100% 100%;
                        .flex-center();
                    }
                }
                .main_3{
                    height:80.5%;.flex-between();
                    .main_3_1{
                        .flex-between();flex-flow:column;
                        width: 23.19%;
                        height: 100%;
                        .main_3_1_1{
                            padding:9.16% 15px 2% 15px;
                            box-sizing: border-box;
                            width:100%;
                            height: 49.66%;
                            background: url(../../assets/main_3_1_1.png) no-repeat center;background-size:100% 100%;
                            .content{
                                padding:10px 0 0 0;
                            }
                        }
                        .main_3_1_2{
                            padding:4% 20px 1% 20px;
                            width:100%;
                            height: 48.88%;
                            background: url(../../assets/main_3_1_2.png) no-repeat center;background-size:100% 100%;
                            .tip{
                                .flex-center();height: 20%;color:#fff;font-size:20px;
                                img{display: block;width: 32px;margin-right: 5px;}
                            }
                            .content{height:90%;}
                        }
                    }
                    .main_3_2{
                        width: 59.84%;height: 100%;.flex-between();flex-flow:column;
                        .main_3_2_1{
                            width: 100%;
                            height:100%;
                            background: rgba(23, 74, 156, 0.6);
                            box-shadow: inset 0px 0px 24px 1px #00B6EF;
                            border-radius: 0px 0px 0px 0px;
                            border: 1px solid #00B6EF;
                            box-sizing: border-box;
                            position: relative;
                            .wrap{
                                top:20px;
                                right:20px;position: absolute;z-index:9997;
                                background: linear-gradient(180deg, rgba(5,24,64,0.8) 0%, rgba(20,69,168,0.8) 100%);
                                box-shadow: inset 0px 0px 24px 1px #4482FF;border-radius: 5px;padding:20px;
                                ul{
                                    li{
                                        margin-bottom: 12px;
                                        .flex-start();
                                        img{display: block;width:20px;margin:0 8px 0 0;}
                                        span{
                                            font-size: 14px;color:#fff;
                                        }
                                        &:last-child{margin:0;}
                                    }
                                    
                                }
                            }
                            .map_content{
                                top:20px;left:20px;position: absolute;z-index:9997;
                                background: linear-gradient(180deg, rgba(5,24,64,0.8) 0%, rgba(20,69,168,0.8) 100%);
                                box-shadow: inset 0px 0px 24px 1px #4482FF;border-radius: 5px;padding:20px 30px;
                                .content{
                                    display: flex;flex-flow: column;margin-bottom: 10px;
                                    p{
                                        font-size:14px;color:#fff;
                                    }
                                    span{
                                        font-size:18px;color:#45E8F7;font-weight:bold;margin:10px 0 0 0;
                                    }
                                    &:last-child{
                                        margin: 0;
                                    }
                                }
                            }
                        }
                        .main_3_2_2{
                            width: 100%;background: url(../../assets/energy/main_3_2_2.png) no-repeat center;background-size:100% 100%;box-sizing: border-box;
                            padding:15px 20px;height: 36.3%;
                        }
                    }
                    .main_3_3{
                        .flex-between();flex-flow:column;
                        width: 15.74%;
                        height: 100%;
                        // .main_3_3_1{
                        //     padding:16px 10px;
                        //     width:100%;
                        //     height: 48.88%;
                        //     background: url(../../assets/main_3_3_1.png) no-repeat center;background-size:100% 100%;box-sizing: border-box;
                        //     .content{
                        //         .wrap{
                        //             overflow: hidden;height:100%;
                        //         }
                        //         overflow: hidden;
                        //         padding: 10px 0 0 0;
                        //     }
                        // }
                        .main_3_3_2{
                            
                            padding:16px 16px 10px 16px;
                            width:100%;
                            height: 48.88%;
                            background: url(../../assets/main_3_3_2.png) no-repeat center;background-size:100% 100%;box-sizing: border-box;
                            .title{height:14%;}
                            .content{
                                .wrap{
                                    overflow: hidden;height:100%;
                                }
                                height:86%;
                                padding: 10px 0 0 0;
                                ul{
                                    li{
                                        border-bottom: 1px solid #008DBD;margin-bottom:20px;padding-bottom:20px;overflow: hidden;
                                        .info_left{
                                            width:40%;float: left;.flex-between();flex-flow:column;
                                            span{
                                                font-size: 16px;color: #FFFFFF;display: block;
                                            }
                                            p{
                                                font-size: 12px;color: #94AFE6;margin-top: 6px;
                                            }
                                            img{
                                                width:88px;height:56px;display: block;
                                            }
                                        }
                                        .info_right{
                                            width:50%;float: right;
                                            .info2{
                                                margin:10px 0 0 0;
                                            }
                                            p{
                                                font-size: 16px;color: #FFFFFF;margin-top:5px;
                                            }
                                            span{
                                                font-size: 12px;color: #94AFE6;display: block;
                                            }
                                        }
                                        &:last-child{
                                            border: 0;margin:0;padding:0;
                                        }
                                    }
                                }
                            }
                        }
                        .main_3_3_3{
                            padding:16px 20px;
                            width:100%;
                            height: 48.88%;
                            background: url(../../assets/main_3_3_3.png) no-repeat center;background-size:100% 100%;box-sizing: border-box;
                            .content{
                                .tab{
                                    height: 14%;.flex-around();
                                    span{
                                        width: 53px;height: 23px;background: #3786C2;border-radius: 4px;font-size: 14px;color: #fff;line-height:23px;text-align: center; 
                                        &.on{
                                            background: #3972E8;
                                        }
                                    }
                                }
                                .tip{
                                    height: 14%;width:100%;
                                    // .time_wrap{
                                    //     .flex-around();
                                    //     .prev{
                                    //         font-size: 12px;color:#fff;width:50%;
                                    //         span{
                                    //             color:#3972E8;margin-left: 10px;cursor: pointer;
                                    //         }
                                    //     }
                                    //     .next{
                                    //         font-size: 12px;color:#fff;width:50%;
                                    //         span{
                                    //             color:#3972E8;margin-right: 10px;cursor: pointer;
                                    //         }
                                    //     }
                                    // }
                                    .tip_wrap{
                                        background: linear-gradient( 90deg, #F69300 0%, rgba(246,147,0,0) 100%);width:100%;border-radius: 15px;margin-top: 10px;
                                        .flex-between();padding:3px 0;
                                        div{width:20%;font-size: 12px;color:#FFF;text-align: center;}
                                        span{width:50%;font-size: 12px;color:#FFF;text-align: center;}
                                        p{font-size: 12px;color:#FFF;width:30%;text-align:center;}
                                    }
                                    
                                }
                                .wrap{
                                    overflow: hidden;
                                    height: 70%;
                                    ul{
                                        li{
                                            div{width:20%;text-align: center;font-size:12px;}
                                            span{width:50%}
                                            p{width:30%;justify-content: center;}
                                        }
                                    }
                                }
                                
                            }
                        }
                    }
                }
            }
        .gridlist1{
            .flex-between();flex-wrap: wrap;height:80%;
            li{
                width:33.33%;height:50%;
                .flex-center();flex-flow: column;position: relative;
                span{
                    position: absolute;top:0;width:100%;left:0;text-align: center;
                    font-size: 18px;color: #fff;
                }
                img{
                    display: block;
                    width:88px;
                }
                p{
                    font-size: 14px;color: #fff;
                }
            }
        }
        
            
        .textlist1 {
            .flex-start();
            height: 100%;
            li {
                width: 33.33%;
                height: 100%;
                border-radius: 4px;
                padding: 0 0 0 ;
                box-sizing: border-box;
                .flex-start();
                .picture{
                    width:100px;height: 100px;
                    position: relative;
                    .img1{position: absolute;top: 0;left:0;width: 100%;height:100%;animation: roate 3s infinite linear;}
                    img{
                        display: block; width: 100%;height:100%;
                    }
                }
                .info{
                    margin:0 0 0 15px;
                    .flex-start();
                    flex-flow: column;
                    align-items: baseline;
                    justify-content: space-around;
                    .num{
                        margin-bottom:2px;
                        .flex-start();
                        color: #45E8F7;
                        font-size: 24px;
                        span {
                            margin:0 5px 0 0;
                            color: #45E8F7;
                            font-size: 24px;
                            font-weight: bold;
                        }
                        b{
                            color: #45E8F7;
                            font-size: 16px;
                            font-weight: normal;
                        }
                    }
                    p {
                        
                        display: block;
                        color: white;
                        font-size: 14px;
                    }
                }
                &:last-child{
                    width: 300px;
                }
            }
        }    
                

        .textlist2 {
            .flex-end();
            height: 100%;
            li {
                width: 50%;
                height: 100%;
                border-radius: 4px;
                padding:10px 0 0 0 ;
                box-sizing: border-box;
                .flex-center();
                .picture{
                    width:100px;height: 100px;
                    position: relative;
                    .img1{position: absolute;top: 0;left:0;width: 100%;height:100%;animation: roate 3s infinite linear;}
                    img{
                        display: block; width: 100%;height:100%;
                    }
                }
                .info{
                    margin:0 0 0 15px;
                    .flex-start();
                    flex-flow: column;
                    align-items: baseline;
                    justify-content: space-around;
                    .num{
                        margin-bottom:2px;
                        .flex-start();
                        color: #45E8F7;
                        font-size: 24px;
                        span {
                            margin:0 5px 0 0;
                            color: #45E8F7;
                            font-size: 24px;
                            font-weight: bold;
                        }
                        b{
                            color: #45E8F7;
                            font-size: 16px;
                            font-weight: normal;
                        }
                    }
                    p {
                        margin-top: 5px;
                        display: block;
                        color: white;
                        font-size: 14px;
                    }
                }
                &:last-child{margin:0;}
            }
        }

        .textlist3 {
            height: 100%;
            li {
                margin-bottom: 5px;
                // height: 20%;
                box-sizing: border-box;
                .flex-center();
                // align-items: flex-end;
                
                width:100%;
                border-radius: 15px;
                padding: 0 10px;
                background: linear-gradient(90deg, #1445A8 0%, rgba(20,69,168,0) 100%);
                .flex-between();
                
                // a{
                //     width:100%;
                //     border-radius: 15px;
                //     padding: 0 10px;
                //     background: linear-gradient(90deg, #1445A8 0%, rgba(20,69,168,0) 100%);
                //     .flex-between();
                    .rank {
                        .flex-start();
                        font-size: 14px;
                        flex: 1;
                        color: @white;
                    
                        b {
                            font-weight: normal;
                            display: block;
                            text-align: center;
                            width: 30px;
                        }
                    
                        img {
                            width: 30px;
                            display: block;
                        }
                    }
                    
                    span {
                        width: 76px;
                        height: 24px;
                        font-size: 14px;
                        color: @white;
                        .flex-center();
                    }
                    
                    p {
                        flex: 1;
                        font-size: 14px;
                        color: @white;
                        line-height: 24px;
                        text-align: right;
                    }
                // }
                &.on1{
                    // a{
                        background: linear-gradient(90deg, #F69300 0%, rgba(246,147,0,0) 100%);
                    // }
                }
                &.on2{
                    
                    // a{
                        background: linear-gradient(90deg, #F6C44C 0%, rgba(246,147,0,0) 100%);
                    // }
                }
                &.on3{
                    
                    // a{
                        background: linear-gradient(90deg, #F6C44C 0%, rgba(246,147,0,0) 100%);
                    // }
                }
            }

        }

        .textlist4 {
            width:100%;
            height: 100%;
            li {
                box-sizing: border-box;
                margin-bottom:6px;
                a{
                    .flex-between();
                    .rank {
                        .flex-start();
                        font-size: 14px;
                        width:10.3%;height:26px;
                        
                        b {
                            border: 1px solid #00B6EF;border-radius: 50%;
                            font-weight: normal;
                            .flex-center();
                            width: 26px;height:26px;
                            color: @white;
                        }
                    
                        img {
                            width: 26px;
                            display: block;
                        }
                    }
                    
                    .username{
                        width: 65%;
                        height: 30px;
                        padding-right:14px;
                        b{
                            font-size: 14px;
                            color: #1856A4;
                            color: @white;
                            min-width:76px;
                            width:30%;
                            padding:0 0 0 10px;
                        }
                        .el-progress{
                            width:70%;
                            .el-progress-bar__outer{
                                height: 14px !important;
                            }
                        }
                        .flex-start();
                        
                        // justify-content: start;
                    }
                    
                    p {
                        width: 30%;
                        text-align: center;
                        font-size: 14px;
                        color: @white;
                        text-align: right;
                        flex: 1;
                    }
                }
                &.on1,&.on2,&.on3{
                    a{
                        .rank{
                            b{
                                border: none;
                            }
                            
                        }
                    }
                    
                    
                }
            }
        }

        .textlist5 {
            height: 100%;
            li {
                // a{
                    // height: 10%;
                    margin-bottom: 10px;
                    .flex-between();
                    
                    div {
                        font-size: 14px;
                        color: @white;
                        width: 40%;
                        text-align: left;
                    }
                    
                    span {
                        font-size: 14px;
                        color: @white;
                        width: 30%;
                        text-align: center;
                    }
                    
                    p {
                        font-size: 12px;
                        color: @white;
                        width: 30%;
                        text-align: right;
                        .flex-end();
                    
                        b {
                            width: 8px;
                            height: 8px;
                            margin-right: 8px;
                            background: white;
                        }
                    
                        &.n10 {
                            color: #55F8D7;
                    
                            b {
                                background: #55F8D7;
                            }
                        }
                    
                        &.n15 {
                            color: #F8B655;
                    
                            b {
                                background: #F8B655;
                            }
                        }
                    
                        &.n17 {
                            color: #00C734;
                    
                            b {
                                background: #00C734;
                            }
                        }
                    
                        &.n18 {
                            color: #0BB5EB;
                    
                            b {
                                background: #0BB5EB;
                            }
                        }
                    
                        &.n20 {
                            color: #44CA90;
                    
                            b {
                                background: #44CA90;
                            }
                        }
                    
                        &.n1 {
                            color: #E55563;
                    
                            b {
                                background: #E55563;
                            }
                        }
                    }
                // }
            }
        }
        .textlist6{
            height:100%;
            .flex-around();flex-wrap: wrap;
            li{
                width:50%;position: relative;
                img{
                    width:130px;height:68px;display: block;margin: 27px auto 0;
                }
                .info{
                    p{
                        font-size: 14px;color: #fff;text-align: center;margin-top: 8px;
                    }
                    .num{
                            font-size: 14px;color: #fff;.flex-center();align-items: flex-end;
                          span{
                              font-size: 30px;color: #fff;text-align: center;display: block;line-height: 1;
                          }  
                    }
                }
            }
        }
        .textlist7{
            li{
                .flex-start();
                .title{
                    .flex-start();font-size: 14px;color:@white;min-width: 70px;
                    span{
                        width: 0.2rem;height: 0.2rem;border-radius: 50%;margin-right: 10px;
                        &.green{
                            background: #77F68C;
                        }
                        &.yellow{
                            background: #F6C44C;
                        }
                        &.white{
                            background: #EBF2FB;
                        }
                    }
                }
                .info{
                    color:#45E8F7;font-size: 24px;margin-left: 20px;
                    span{
                        color:#45E8F7;font-size: 24px;font-weight: bold;
                    }
                }
            }
        }
        .title {
            height: 10%;
            .flex-center();
            
            img{display: block;height:20px;width: auto;}
        }

        .content {
            height: 90%;
            .main {
                // padding: 1% 0;
                height: 100%;
                box-sizing: border-box;
            }
        }
        .container{
            width:100%;height:100%;
            a{display: none;}
            .logo-text{display: none;}
            canvas{opacity: 0.8 !important;}
        }
        .infowindow {
            padding: 0.2rem 0.2rem;
            // background: #4482FF;
            background: linear-gradient(180deg, rgba(5, 24, 64, 0.8) 0%, rgba(20, 69, 168, 0.8) 100%);
            box-shadow: inset 0px 0px 24px 1px #4482FF;
            border-radius: 5px;
            border-radius: 0.1rem;
            position: relative;

            p {
                font-size: 0.32rem;
                text-align: center;
                color: @white;
            }
            &.infowindow1{
                background: linear-gradient(180deg, rgba(5, 24, 64, 0.8) 0%, rgba(0,255,212, 0.8) 100%);
                box-shadow: inset 0px 0px 24px 1px #00FFD4;
                p{
                    text-align: left;
                }
            }
            // &::after{
            //     position: absolute;
            //     left:50%;bottom:0%;
            //     border-top: 0.2rem solid #000;
            //     border-right: 0.2rem solid transparent;
            //     border-left: 0.2rem solid transparent;
            //     content:''

            // }
            // &::before{
            //     content:'';
            //       position: absolute;
            //       left:50%;bottom:0%;
            //       border-top: 0.2rem solid #000;
            //       border-right: 0.2rem solid transparent;
            //         border-left: 0.2rem solid transparent;
            //         transform: translate(-50%,100%);
            // }
        }
    


        }

    }
</style>
